import React, {useCallback, useEffect, useState} from 'react';

import {Area, AreaChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis} from 'recharts';

import {makeDateURLSafe, nowSimpleDate} from '../../../utils/dateFunctions';
import {arrayFunctionForDashboardGraph} from '../../../utils/arrayFunction';

export default function Dashboard({authFetch}) {
    const [types, setTypes] = useState([]);
    const [origDateReadings, setOrigDateReadings] = useState([]);

    const fetchUserTypes = useCallback(async () => {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/type/all`);
            if (response.ok) {
                const data = await response.json();
                setTypes(data);
            }
        } catch (err) {
            console.error("Error fetching user types:", err.message);
        }
    }, [authFetch]);

    const fetchUserDateReadings = useCallback(async () => {
        const simpleNowDate = nowSimpleDate();
        const date = makeDateURLSafe(simpleNowDate);
        const response = await authFetch(`${process.env.REACT_APP_API_URL}/reading/date/${date}`);
        if (response.ok) {
            const data = await response.json();
            setOrigDateReadings(data);
        }
    }, [authFetch]);

    useEffect(() => {
        (async () => {
            try {
                await fetchUserTypes();
                await fetchUserDateReadings();
            } catch (err) {
                console.error(err);
                alert(err.message);
                window.location.href = "/login";
            }
        })();
    }, [fetchUserTypes, fetchUserDateReadings]);

    const combinedArray = arrayFunctionForDashboardGraph(origDateReadings, types);

    const strokeArray = ['#8884d8', '#82ca9d', '#D8A184FF', '#BA82CAFF'];
    return types.length > 0 && (
        <>
            <h2>Dashboard</h2>

            <AreaChart width={600} height={300} data={combinedArray}>
                {types.map((type, i) => {
                    return (<Area type="monotone" key={type._id} dataKey={type.name} name={type.name}
                                  stroke={strokeArray[i]}
                                  fillOpacity="0.5"
                                  fill={strokeArray[i]}
                                  dot={false}/>);
                })};
                <CartesianGrid stroke="#ccc"/>
                <XAxis dataKey="time"/>
                <YAxis/>
                <Tooltip/>
                <Legend/>
            </AreaChart>
        </>
    );
}